import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Logo from "../video/Mariniz Logo Gold.png";
import axios from "axios";
import config from "../../function/config";
import { toast } from "react-toastify";




export default function HomeNav() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [isScrolled, setIsScrolled] = useState(false);

  // Track scrolling
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Automatically flip twice on page load
  const handleFlip = () => {
    setIsFlipped(false); // Temporarily set to false
    setTimeout(() => setIsFlipped((prevState) => !prevState), 10); // Reapply the flipped state
  };

 

  const scrollToTop = () => {
    window.location.href = "/"
    
  };

  // signin
  const [username, setusername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [usernameError, setUsernameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [Signin, setSignin] = useState("Signin");
    // Validate username
    const validateUsername = (value) => {
      if (!value) {
        setUsernameError("Username is required");
      } else {
        setUsernameError("");
      }
    };
  
    // Validate password
    const validatePassword = (value) => {
      if (!value) {
        setPasswordError("Password is required");
      } else if (value.length < 4) {
        setPasswordError("Password must be at least 4 characters");
      } else {
        setPasswordError("");
      }
    };
  
    const handleSubmit = async () => {
      setLoading(true);
      const data = {
        email: username,
        password: password,
      };
      try {
        const response = await axios.post(
          `${config.base_url}/api/HappyMarineShipping/login`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.status === 200) {
          setLoading(false);
          console.log(response);
          localStorage.setItem("token", response.data.token);
          if (response.data.is_admin === true) {
            localStorage.setItem("admin", "t");
            console.log("Admin token:", response.data.token); // ✅ log admin token
            window.location.href = "/adminHome";
          } else {
            window.location.href = '/userHome'
          }
        } else {
          console.log(response);
          toast.error(response.data.message, {
            autoClose: 3000,
            position: "top-right",
          });
          setLoading(false);
        }
      } catch (err) {
        console.log("error2", err);
        toast.error("Error", {
          autoClose: 3000,
          position: "top-right",
        });
        setLoading(false);
      }
    };
  
    const [showPassword, setShowPassword] = useState(false);
     const [isLoginOpen, setIsLoginOpen] = useState(false);

   const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [image,setImage] = useState('')


  // Error states
  const [emailError, setEmailError] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);


    
  
  // Email validation (simple regex)
  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(!emailRegex.test(value));
  };
  
  const validateMobile = (value) => {
    const mobileRegex = /^\+\d{7,15}$/;
    setMobileError(!mobileRegex.test(value));
  };
  
  
  // Confirm Password validation (must match Password)
  const validateConfirmPassword = (value) => {
    setConfirmPasswordError(value !== password);
  };
  
  
    const handleSubmitSignup = async () => {
    // Run all validations first
    validateUsername(username);
    validateEmail(email);
    validateMobile(mobile);
    validatePassword(password);
    validateConfirmPassword(confirmPassword);
  
    // Check for any errors or empty required fields
    if (
      usernameError ||
      emailError ||
      mobileError ||
      passwordError ||
      confirmPasswordError ||
      !firstName ||
      !lastName ||
      !username ||
      !email ||
      !mobile ||
      !password ||
      !confirmPassword
    ) {
      toast.error("Please fix form validation errors before submitting.", {
        autoClose: 1500,
        position: "top-right",
      });
      return;
    }
  
    setLoading(true);
  
    const formData = new FormData();
    formData.append("email", email);
    formData.append("username", username);
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("phone", mobile);
    formData.append("address", address);
    formData.append("password", password);
    if (image) {
      formData.append("image", image);
    }
  
    try {
      const response = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/signup`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.data.status === 200) {
    toast.success("Registered Successfully", {
      autoClose: 1500,
      position: "top-right",
      onClose: () => navigate("/login"),
    });
  } else if (
    response.data.status === 400 &&
    response.data.message === "Email already exists"
  ) {
    toast.error("Email already exists", {
      autoClose: 1500,
      position: "top-right",
    });
  } else if (
    response.data.status === 400 &&
    response.data.message === "Username already exists"
  ) {
    toast.error("Username already exists", {
      autoClose: 1500,
      position: "top-right",
    });
  } else {
    toast.error("Something went wrong. Try again.", {
      autoClose: 1500,
      position: "top-right",
    });
  }
  
    } catch (err) {
      console.error(err);
      toast.error("Network error. Please try again.", {
        autoClose: 1500,
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate('')


    const [resetEmail, setResetEmail] = useState("");
const [resetLoading, setResetLoading] = useState(false);

const handleForgotPassword = async () => {
  if (!resetEmail) {
    toast.error("Please enter your email");
    return;
  }
  setResetLoading(true);
  try {
    const res = await axios.post(`${config.base_url}/api/HappyMarineShipping/forgot-password/`, {
      email: resetEmail,
    });
    if (res.data.status === 200) {
      toast.success("Reset link sent to your email");
      setSignin("Signin");
    } else {
      toast.error(res.data.message);
    }
  } catch (err) {
    toast.error("Something went wrong");
  } finally {
    setResetLoading(false);
  }
};

  return (
    <div>
      <nav>
        <div className="bg-[#123d5f]   border-b border-white">
        <div className="px-[130px] sm:px-[10px]  3xl:px-[40px] py-2 flex justify-end items-center xs:justify-center">
           
            <div className="flex items-center gap-2">
      <div className="flex ml-auto gap-4 items-center px-3 ">
               <Link
                 to={"https://www.facebook.com/groups/2708905909353211"}
                 className=" "
               >
                 <i class="fa-brands hover:scale-125 duration-200 hover:text-blue-400  fa-facebook text-2xl text-blue-600"></i>
               </Link>
               <Link to={"https://www.instagram.com/data.marine/?hl=en"}>
                 <i class="fa-brands fa-instagram hover:scale-125 duration-200 hover:text-pink-400 text-2xl text-pink-500"></i>
               </Link>
               <Link
                 target="_blank"
                 to={
                   "https://wa.me/971503505898?text=Hello%20Happy%20Marine%20Shipping,%20I%20would%20like%20to%20inquire%20about%20your%20services."
                 }
               >
                 <i class="fa-brands fa-whatsapp hover:scale-125 duration-200 hover:text-green-400 text-2xl text-green-500"></i>
               </Link>
             </div>
    </div>
         </div>
        
         <hr className="border-1 hidden L:block border-white " />
         

         <div
  className={`flex items-center ${
    isScrolled
      ? "fixed top-0 left-0 w-full bg-[#123d5f] text-[#d1a460] hover:text-blue-500 shadow-md z-50 pointer-events-auto"
      : ""
  }`}
>
  <div
    className={`md:mt-0 2xl:mt-1 mt-5 mb-5 pl-14 xl:pl-0  h-[75px] bg-[#123d5f] text-[#d1a460] border-l border-t border-b items-center border-r rounded-r-full L:border-none 2xl:shadow-none  md:border-none shadow-xl 2xl:w-full transition-all duration-300 w-[95%] md:w-full L:px-5 flex justify-between  relative`}
  >
    {/* Left Section: Menu Icon and Logo */}
    
     
      <Link to={"/"} className="L:m-auto" onClick={scrollToTop}>
        <img
          src={Logo}
          className="w-[270px]   xl:w-[220px] object-contain cursor-pointer"
          alt="Logo"
        />
      </Link>

      <div className="">
        <i
          onClick={toggleSidebar}
          className={`bx ${isSidebarOpen ? "bx-x" : "bx-menu"} hidden L:block  mt-5 text-white text-[40px] cursor-pointer`}
        ></i>
      </div>
  

    {/* Right Section: Navigation Links */}
    <div className="L:hidden flex items-center  xl:gap-4  gap-10">
      <Link
        to="/ship-for-sale"
        onClick={() => (window.location.href = "/ship-for-sale")}
        className={`text-sm transition-all duration-300 ${
          isScrolled ? "hover:text-blue-500" : "hover:text-white"
        }`}
      >
        Ship Sale/Purchase
      </Link>
      <Link
        to="/map/ship-chartering"
        onClick={() => (window.location.href = "/map/ship-chartering")}
        className={`text-sm transition-all duration-300 ${
          isScrolled ? "hover:text-blue-500" : "hover:text-white"
        }`}
      >
        Open Ships
      </Link>
      <Link
        to="/map/open-cargo"
        onClick={() => (window.location.href = "/map/open-cargo")}
        className={`text-sm transition-all duration-300 ${
          isScrolled ? "hover:text-blue-500" : "hover:text-white"
        }`}
      >
        Open Cargo
      </Link>
      <Link
        to="/supplyEq"
        onClick={() => (window.location.href = "/supplyEq")}
        className={`text-sm transition-all duration-300 ${
          isScrolled ? "hover:text-blue-500" : "hover:text-white"
        }`}
      >
        Supply Equipments
      </Link>
      
      <Link
        to="/contact"
        onClick={() => (window.location.href = "/contact")}
        className={`text-sm transition-all duration-300 ${
          isScrolled ? "hover:text-blue-700" : "hover:text-white"
        }`}
      >
        Contact Us
      </Link>

      <button
      type='button'
        onClick={() => setIsLoginOpen(true)}
        className={` w-[100px] shadow-xl text-center hover:bg-blue-500 ml-10 bg-blue-600 rounded-xl p-2 py-3 text-white transition-all duration-300 `}
      >
        Login
      </button>
      
    </div>


    {/* CTA Button on smaller screens only */}
    <Link
      onClick={() => setIsLoginOpen(true)}
      className="h-[75px] L:hidden shadow-xl py-2 bg-[#d1a460] hover:bg-[#806338] transition-all border rounded-r-full"
    >
      <p className="text-sm transition-all duration-300 text-black rounded p-4">
        + Register your Ship
      </p>
    </Link>
  </div>

  {/* Sidebar for small screens */}
  <div
  className={`fixed top-0 right-0 h-full bg-gray-100 shadow-lg transform ${
    isSidebarOpen ? "translate-x-0" : "translate-x-full"
  } transition-transform duration-300 z-50 w-[250px]`}
>
  <div className="p-4">
    <div className="flex justify-between">
      <h2 className="text-lg font-bold mb-4">Menu</h2>
      <p onClick={toggleSidebar}>
        <i className="fa-solid fa-circle-chevron-right text-xl"></i>
      </p>
    </div>
    <ul className="space-y-4">
      <li><Link to="/" className="text-blue-500 block" onClick={toggleSidebar}>Home</Link></li>
      <li><Link to="/ship-for-sale" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Ship Sale/Purchase</Link></li>
      <li><Link to="/map/ship-chartering" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Open ships</Link></li>
      <li><Link to="/map/open-cargo" className="text-gray-800 hover:text-blue-300 block" onClick={toggleSidebar}>Open Cargo</Link></li>
      <li><Link to="/supplyEq" className="text-gray-800 hover:text-blue-300 block" onClick={toggleSidebar}>Supply Equipments</Link></li>
      <li><Link to="/contact" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Contact Us</Link></li>
      <li><Link to="/login" className="bg-blue-600 text-white  rounded py-2 px-2 block text-center" onClick={toggleSidebar}>Login</Link></li>
      <li><Link onClick={() => setIsLoginOpen(true)} className="bg-[#d1a460] text-black hover:bg-[#af9164] rounded py-2 px-2 block text-center" >+ Register your Ship</Link></li>
    </ul>
  </div>
</div>

{isLoginOpen && (
<div className="fixed inset-0  bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-gray-50 p-5  rounded-lg w-[40%] xm:w-[95%] relative">
        {/* Close button */}
        <button
          className="absolute right-3 top-3 text-gray-500 hover:text-red-500"
           onClick={() => setIsLoginOpen(false)}
        >
          ✕
        </button>

        {Signin === "Signin" && (
          <>
             <div>
              <img src={Logo} className="w-[276px]  m-auto -mt-4 " alt="" />
              <h1 className="text-center text-[24px] ">Login</h1>
              </div>
            <form
              className="flex flex-col mt-3 gap-7"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSubmit();
                }
              }}
            >
              {/* Username Field */}
              <input
                type="text"
                placeholder="Email or Username"
                value={username}
                onChange={(e) => {
                  setusername(e.target.value);
                  validateUsername(e.target.value);
                }}
                onBlur={() => validateUsername(username)}
                className={`w-full px-3 py-2 border ${
                  usernameError ? "border-red-500" : "border-gray-300"
                } rounded-lg`}
              />

              {/* Password Field */}
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    validatePassword(e.target.value);
                  }}
                  onBlur={() => validatePassword(password)}
                  className={`w-full px-3 py-2 border ${
                    passwordError ? "border-red-500" : "border-gray-300"
                  } rounded-lg`}
                />
                <div
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="fa-solid fa-eye-slash"></i>
                  ) : (
                    <i className="fa-solid fa-eye"></i>
                  )}
                </div>
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="flex justify-between items-center text-sm">
                <p>
                  Not a Member?{" "}
                  <Link
                    onClick={() => setSignin("Signup")}
                    className="text-[#d1a460] font-semibold"
                  >
                    Signup
                  </Link>
                </p>
                <button
                  type="button"
                  onClick={() => setSignin("resetpswd")}
                  className="text-blue-500 hover:underline"
                >
                  Forgot Password?
                </button>
              </div>

              {/* Login Button */}
              <button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
                className="w-full bg-[#253356] text-white py-2 rounded-lg hover:bg-[#1b2a4f] disabled:cursor-not-allowed"
                disabled={
                  usernameError || passwordError || !username || !password
                }
              >
                {loading ? (
                  <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white rounded-full m-auto animate-spin"></span>
                ) : (
                  "Login"
                )}
              </button>
            </form>
          </>
        )}

        {/* Reset Password View */}
        {Signin === "resetpswd" && (
          <>
            <div className="flex justify-between items-center">
              <h1 className="text-xl">Recover Password</h1>
              <button onClick={() => setSignin("Signin")}>
                <i className="bx bx-arrow-back text-3xl text-blue-500"></i>
              </button>
            </div>
            <p className="mt-2 text-gray-500 text-sm">
              Enter your Email and instructions will be sent to you!
            </p>
            <form className="mt-4" onSubmit={(e) => { e.preventDefault(); handleForgotPassword(); }}>
  <input
    type="email"
    placeholder="Enter your Email"
    value={resetEmail}
    onChange={(e) => setResetEmail(e.target.value)}
    className="w-full rounded-lg border py-3 p-2"
  />
  <button
    type="submit"
    disabled={resetLoading}
    className="mt-4 bg-[#FB9678] w-full p-3 rounded-lg text-white font-semibold hover:bg-[#e97a58]"
  >
    {resetLoading ? "Sending..." : "RESET"}
  </button>
</form>
          </>
        )}

        {/* Signup */}
          {Signin === "Signup" && (
            <>
              <div>
               <img src={Logo} className="w-[276px]  m-auto -mt-4 " alt="" />
                <h1 className="text-center text-[24px] ">Signup</h1>
              </div>

             <form
  className="flex flex-col gap-7 mx-auto mt-5"
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmitSignup();
    }
  }}
>
  {/* First Name */}
  <div className="relative flex gap-10 w-full group">
    <input
      type="text"
      placeholder="First Name"
      value={firstName}
      onChange={(e) => setFirstName(e.target.value)}
      className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
    />

    <input
      type="text"
      placeholder="Last Name"
      value={lastName}
      onChange={(e) => setLastName(e.target.value)}
      className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
    />
  </div>

  {/* Username */}
  <div className="relative flex gap-10 w-full group">
    <input
      type="text"
      placeholder="Username"
      value={username}
      onChange={(e) => {
        setusername(e.target.value);
        validateUsername(e.target.value);
      }}
      onBlur={() => validateUsername(username)}
      className={`w-[50%] px-1 py-1 border-b ${
        usernameError ? "border-red-500" : "border-gray-400"
      } focus:outline-none focus:ring-0 bg-transparent`}
    />

     <input
      type="email"
      placeholder="Email"
      value={email}
      onChange={(e) => {
        setEmail(e.target.value);
        validateEmail(e.target.value);
      }}
      onBlur={() => validateEmail(email)}
      className={`w-[50%] px-1 py-1 border-b ${
        emailError ? "border-red-500" : "border-gray-400"
      } focus:outline-none focus:ring-0 bg-transparent`}
    />
  </div>

  {/* Company Name */}
  <div className="relative flex gap-10 w-full group">
    <input
      type="text"
      placeholder="Company Name"
      value={companyName}
      onChange={(e) => setCompanyName(e.target.value)}
      className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
    />
 <div className="w-[50%]">
    <input
      type="text"
      placeholder="Mobile Number"
      value={mobile}
      onChange={(e) => {
        setMobile(e.target.value);
        validateMobile(e.target.value);
      }}
      onBlur={() => validateMobile(mobile)}
      className={`w-full px-1 py-1 border-b ${
        mobileError ? "border-red-500" : "border-gray-400"
      } focus:outline-none focus:ring-0 bg-transparent`}
    />

    {/* ✅ Show error message */}
    {mobileError && (
      <p className="text-red-500 italic text-sm mt-1">
        *Please enter a valid mobile number (e.g., +971501234567).
      </p>
    )}
  </div>
  </div>

  {/* Address */}
  <div className="relative w-full group">
    <input
      type="text"
      placeholder="Address"
      value={address}
      onChange={(e) => setAddress(e.target.value)}
      className="w-full px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
    />
  </div>

 

 

  {/* Password */}
  <div className="relative w-full group">
  <input
    type={showPassword ? "text" : "password"}
    placeholder="Password"
    value={password}
    onChange={(e) => {
      setPassword(e.target.value);
      validatePassword(e.target.value);
    }}
    onBlur={() => validatePassword(password)}
    className={`w-full px-1 py-1 border-b ${
      passwordError ? "border-red-500" : "border-gray-400"
    } focus:outline-none focus:ring-0 bg-transparent pr-8`}  // Add pr-8 for icon space
  />

  {/* Eye icon */}
  <div
    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
    onClick={() => setShowPassword(!showPassword)}
  >
    {showPassword ? <i class="fa-solid fa-eye-slash"></i> : <i class="fa-solid fa-eye"></i>}
  </div>

  {passwordError && (
    <p className="text-red-500 italic text-sm mt-1">
      *Password must be at least 6 characters and contain at least 1 letter and 1 number.
    </p>
  )}
</div>



  {/* Confirm Password */}
  <div className="relative w-full group">
  <input
    type={showConfirmPassword ? "text" : "password"}
    placeholder="Confirm Password"
    value={confirmPassword}
    onChange={(e) => {
      setConfirmPassword(e.target.value);
      validateConfirmPassword(e.target.value);
    }}
    onBlur={() => validateConfirmPassword(confirmPassword)}
    className={`w-full px-1 py-1 border-b ${
      confirmPasswordError ? "border-red-500" : "border-gray-400"
    } focus:outline-none focus:ring-0 bg-transparent pr-8`}
  />

  {/* Eye icon */}
  <div
    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
  >
    {showConfirmPassword ? <i class="fa-solid fa-eye-slash"></i> : <i class="fa-solid fa-eye"></i>}
  </div>

  {confirmPasswordError && (
    <p className="text-red-500 italic text-sm mt-1">
      *Passwords do not match.
    </p>
  )}
</div>



   <div className='flex items-center gap-4'>
                <label className='text-gray-400 ' htmlFor="image">Image:</label>
                <input
                  className='px-2  rounded-xl'
                  type="file"
                  onChange={(e) => setImage(e.target.files[0])}
                  id='image'
                />
              </div>

  {/* Signup Button */}
  <button
    type="submit"
    onClick={(e) => {
      e.preventDefault();
      handleSubmitSignup();
    }}
    className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 disabled:cursor-not-allowed transition duration-200 disabled:bg-gray-300"
    disabled={
      usernameError ||
      emailError ||
      mobileError ||
      passwordError ||
      confirmPasswordError ||
      !username ||
      !email ||
      !mobile ||
      !password ||
      !confirmPassword
    }
  >
    {loading ? (
      <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white mt-[4px] mb-[4px] rounded-full m-auto animate-spin"></span>
    ) : (
      "Signup"
    )}
  </button>

  {/* Already have account? */}
  <div className="text-sm text-center">
    Already have an account?{" "}
    <Link onClick={() => setSignin("Signin")} className="text-[#d1a460] font-semibold">
      Login
    </Link>
  </div>
</form>

            </>
          )}
         
      </div>
    </div>
)}



</div>


        </div>
      </nav>
    </div>
  );
}
